<div class="mask  d-flex justify-content-center align-items-center">
    <div class="container mt-5 pt-5">
        <section>
            <div class="row">
                <div class="col-12">
                    <div class="card z-depth-2">
                        <div class="card-body p-0">

                            <div class="row mx-0">

                                <div class="col-lg-6 py-5 px-md-5 d-none d-lg-block">
                                    <div class="view">
                                        <img src="../../../../../assets/img/Authentication.svg" class="img-fluid mt-lg-5"
                                            alt="Trakly Authentication">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-12 cloudy-knoxville-gradient accent-3 py-5 px-md-5">
                                    <form class="text-center border border-light p-5 w-100" (ngSubmit)="ConfirmRegistration()">
                                        <img src="../../../assets/img/Trakly_Logo_3.png" class="img-fluid" alt="Responsive image">
                                        <p class="h2 mb-4">Welcome to Trakly!</p>
                                        <p class="mb-4">Give us a moment while we get things ready for you!</p>
                
                                        <!--Error Display-->
                                        <div *ngIf="showError" class="alert alert-danger" role="alert">
                                            Unable to confirm registration, either the link has expired or an error occured
                                        </div>
                
                                        <!--Success Display-->
                                        <div *ngIf="showSuccess" class="alert alert-success" role="alert">
                                            Registration Confirmed, you will be taken to the password page shortly...
                                        </div>
                
                                        <!--Loading display-->
                                        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
